// Import Packages
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

// Import Pages
import {TextInput} from '../../../FlowConfigurationInputs/TextInput/NewTextInput';

// Import Recoil
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {activeAutom, changedFields, initialActions, saveAvailable} from "../../../../recoil-store/recoil-state";

import DBTable from "../../../FlowConfigurationInputs/DBTable/DBTable";
import {CheckIfFlowUpdated} from "../../../../helpers/helper";
import FieldLabel from "../../../FlowConfigurationInputs/FieldLabel/FieldLabel";

function Set({action, variables, setOpenVariable, automId, setAlert, automVersionId}) {
    const {t} = useTranslation();
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);
    const [dataType, setDataType] = useState('table');

    const label = 'CONTENT.CONFIGURATION-FORM.MATE-DB.SET.';

    const headers = [label + 'KEY', label + 'VALUE'];
    const options = {
        tableData: {headers, title: label + 'DATA'}
    };


    return (
        <div>
            <div className="form-element">
                <DBTable action={action} inputName="value" automVersionId={automVersionId}
                         options={options.tableData}
                         isRequired={false} setOpenVariable={setOpenVariable}
                         automId={automId} headerWithVariable={true}/>
                <small
                    className="conf-field-desc"><em>{t(label + 'DATA-HELPER', {type: 'string'})}</em></small>
            </div>
        </div>
    );
}

export default Set;